import React, { useState, useEffect } from "react";
import { useParams, Link, Outlet, useNavigate } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "react-query";
import useApi from "../../hooks/useApi";
import usePagination from "../../hooks/usePagination";
import useReload from "../../hooks/useReload";
import { FilterBar } from "../../widgets";
import moment from "moment";

import ClientPolicyRequirementInfo from "../clients/ClientPolicyRequirementInfo";
import PolicyItemStatus from "../../widgets/PolicyItemStatus";

const ClientPolicies = () => {
  const { reload } = useReload();
  const { id = "" } = useParams();
  const { Paginate, searchParamString } = usePagination();
  const { api, abortSignal, auth } = useApi();
  const navigate = useNavigate();

  const getPolicies = async (searchString) => {
    try {
      const url = `/policies/client-policies${searchString}`;
      const { data } = await api.list(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: policies } = useQuery(
    ["expiringPolicies", searchParamString, auth],
    ({ queryKey }) => getPolicies(queryKey[1])
  );

  return (
    <>
      <section id="content" className="content">
        <div className="content__header content__boxed">
          <div className="content__wrap">
            {/* <!-- Breadcrumb --> */}
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/client-policies">My Policies</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  List
                </li>
              </ol>
            </nav>
            {/* <!-- END : Breadcrumb --> */}

            <h1 className="page-title mb-0 mt-2">Policies</h1>

            <p className="lead">
              List of all policies with insurrance companies
            </p>

            <div className="d-md-flex align-items-baseline my-3">
              <FilterBar />
            </div>
          </div>
        </div>
        <div className="content__boxed">
          <div className="content__wrap">
            <div className="table-responsive bg-white">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Info</th>
                    <th>Type</th>
                    <th>Company</th>
                    <th>Expires</th>
                    <th>Policy Number</th>
                    <th className="text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {policies &&
                    policies.map((policy) => (
                      <tr key={policy.id}>
                        <td>
                          {<ClientPolicyRequirementInfo policy={policy} />}
                        </td>
                        <td>
                          {/* <Link to={`/policies/${policy.id}`} className="btn-link"> */}
                          {policy.PolicyType.name}
                          {/* </Link> */}
                        </td>
                        <td>
                          <span className="fw-bold">{policy.Company.name}</span>
                        </td>
                        <td>
                          <>
                            <span>
                              {moment(policy?.expires).format("DD/MM/YYYY") ||
                                ""}
                            </span>
                            <p className="text-muted">
                              {policy?.expires &&
                                moment().to(moment(policy?.expires))}
                            </p>
                          </>
                        </td>
                        <td>{policy.policyNumber}</td>

                        <td className="text-center fs-5">
                          <PolicyItemStatus status={policy.status} />
                        </td>
                        {/* <td className="text-center">-</td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
              <Paginate />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ClientPolicies;
